import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { onSignOutSuccess } from "store/auth/sessionSlice";
import { setUser, initialState } from "store/auth/userSlice";
import useAuth from "./useAuth";
import appConfig from "configs/app.config";

const IDLE_LIMIT = 60 * 60 * 1000; // 1 hour

export default function useSessionTimeout() {
  const timer = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { authenticated } = useAuth();

  useEffect(() => {
    if (!authenticated) return;

    const resetTimer = () => {
      if (timer.current) clearTimeout(timer.current);

      timer.current = setTimeout(() => {
        dispatch(onSignOutSuccess());
        dispatch(setUser(initialState));
        navigate(appConfig.unAuthenticatedEntryPath, { replace: true });
      }, IDLE_LIMIT);
    };

    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
      "click",
    ];

    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer(); // start timer

    return () => {
      if (timer.current) clearTimeout(timer.current);

      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [authenticated, dispatch, navigate]);
}
